import type { StateCreator } from "zustand";

import type { ZGlobalCreateTask } from "./types";

export const globalCreateTaskSlice: StateCreator<ZGlobalCreateTask> = (
  set,
  get,
) => ({
  isCreateMoreMode: false,
  setIsCreateMoreMode: isCreateMoreMode => {
    set({ isCreateMoreMode });
  },

  isOpenGlobalCreateTask: false,
  setIsOpenGlobalCreateTask: isOpenGlobalCreateTask => {
    set({ isOpenGlobalCreateTask });
  },

  isMaximized: false,
  toggleIsMaximized: () => {
    const { isMaximized } = get();
    set({ isMaximized: !isMaximized });
  },

  newTaskData: {
    content: "",
    assignee_ids: [],
    due_date: new Date().toISOString(),
    is_urgent: false,
    remind_at: null,
    task_entities: [],
  },
  setNewTaskData: data => {
    set(state => {
      return { newTaskData: { ...state.newTaskData, ...data } };
    });
  },
  hasSetAssignee: false,
  setHasSetAssignee: hasSetAssignee => {
    set({ hasSetAssignee });
  },
  updateAssigneeById: assigneeId => {
    set(state => {
      const assigneeIds = state.newTaskData.assignee_ids ?? [];
      const assigneeIndex = assigneeIds.indexOf(assigneeId);
      if (assigneeIndex === -1) {
        return {
          newTaskData: {
            ...state.newTaskData,
            assignee_ids: [...assigneeIds, assigneeId].filter(Boolean),
          },
        };
      } else {
        if (assigneeIds.length < 2) {
          return state;
        }
        return {
          newTaskData: {
            ...state.newTaskData,
            assignee_ids: [
              ...assigneeIds.slice(0, assigneeIndex),
              ...assigneeIds.slice(assigneeIndex + 1),
            ].filter(Boolean),
          },
        };
      }
    });
  },
  updateTaskEntity: taskEntity => {
    set(state => {
      const { task_entities, ...restTaskData } = state.newTaskData;
      const oldTaskEntities = task_entities ?? [];
      const taskEntityIndex = oldTaskEntities.findIndex(
        entity => entity.object_id === taskEntity.object_id,
      );

      if (taskEntityIndex === -1) {
        return {
          newTaskData: {
            task_entities: [...oldTaskEntities, taskEntity],
            ...restTaskData,
          },
        };
      } else {
        return {
          newTaskData: {
            ...state.newTaskData,
            task_entities: [
              ...oldTaskEntities.slice(0, taskEntityIndex),
              ...oldTaskEntities.slice(taskEntityIndex + 1),
            ],
          },
        };
      }
    });
  },

  clearNewTaskData: () => {
    set({
      newTaskData: {
        task_id: undefined,
        content: "",
        assignee_ids: [],
        due_date: new Date().toISOString(),
        is_urgent: false,
        remind_at: null,
        task_entities: [],
      },
      hasSetAssignee: false,
      triggerEditorClear: true,
    });

    setTimeout(() => {
      set({ triggerEditorClear: false });
    }, 10);
  },

  triggerEditorFocus: false,
  setTriggerEditorFocus: triggerEditorFocus => {
    set({ triggerEditorFocus });
    if (triggerEditorFocus) {
      setTimeout(() => {
        set({ triggerEditorFocus: false });
      }, 10);
    }
  },
  triggerEditorClear: false,
  setTriggerEditorClear: triggerEditorClear => {
    set({ triggerEditorClear });
    if (triggerEditorClear) {
      setTimeout(() => {
        set({ triggerEditorClear: false });
      }, 10);
    }
  },
});
